import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import "./polymarket.css";
import ServiceFooter from "../../ServiceFooter";

import { useState } from "react";

import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useRef } from "react";
import { useEffect } from "react";

const Polymarket = () => {
  const [isPrevSecDisabled, setIsPrevSecDisabled] = useState(true);
  const [isNextSecDisabled, setIsNextSecDisabled] = useState(false);

  const handleSlideSecChange = (swiper) => {
    setIsPrevSecDisabled(swiper.isBeginning);
    setIsNextSecDisabled(swiper.isEnd);
  };

  const cardRefs = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      const viewportHeight = window.innerHeight;

      cardRefs.current.forEach((card, index) => {
        if (!card) return;

        const rect = card.getBoundingClientRect();
        const scrollRatio = Math.min(
          1,
          Math.max(0, 1 - rect.top / viewportHeight)
        );

        const easingFactor = Math.pow(scrollRatio, 2); // Smooth easing effect

        const initialTransforms = [
          { x: -29, y: -66, rotateZ: -16 },
          { x: 30, y: -49, rotateZ: 18 },
          { x: -24, y: 2, rotateZ: 19 },
          { x: 24, y: 4, rotateZ: -21 },
        ];

        const targetX = initialTransforms[index].x * (1 - easingFactor);
        const targetY = initialTransforms[index].y * (1 - easingFactor);
        const targetRotation =
          initialTransforms[index].rotateZ * (1 - easingFactor);

        card.style.transform = `
          translate3d(${targetX}%, ${targetY}%, 0px)
          scale3d(1, 1, 1)
          rotateZ(${targetRotation}deg) 
          skew(0deg, 0deg)
        `;
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <header>
        <NewHead />
      </header>

      <Helmet>
        <title>Polymarket clone script</title>

        <meta name="title" content="Polymarket clone script" />
        <meta
          name="description"
          content="Develop your Polymarket clone script in simple steps. Have a call with our decentralised prediction marketplace experts. To learn more about Polymarket clone script"
        />

        <meta property="og:title" content="Polymarket clone script" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/polymarket-clone-script"
        />
      </Helmet>

      <main className="poly-main">
        {/* hero */}
        <article className="poly-hero primary__landing-content-container">
          <h1 className="poly-hero-title">Polymarket Clone Script</h1>
          <p className="poly-hero-content">
            Entrepreneurs and investors looking to make profit from prediction
            market platforms can benefit from our Polymarket clone script.
          </p>
          <div className="d-flex align-items-center justify-content-center">
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="primary-landing-main-btn re-hero-btn"
            >
              <div className="re-btn-txt">Get Free Consultation</div>
              <span className="mx-2 right-arr">
                <i className="fa-solid fa-arrow-right"></i>
              </span>
            </button>
          </div>
        </article>

        <div className="poly-hero-card-outer">
          <article className="primary__landing-content-container">
            <div className="poly-hero-card">
              <img
                src={require("../../../image/polymarket/hero-card-header.webp")}
                alt="Polymarket clone script"
                className="poly-hero-card-header-img"
              />
              <div className="row g-4 mx-0 poly-hero-card-row">
                <div className="col-md-6">
                  <div
                    ref={(el) => (cardRefs.current[0] = el)}
                    className="poly-hero-card-img one"
                  >
                    <img
                      src={require("../../../image/polymarket/hero-card-img-one.webp")}
                      alt="Polymarket clone script"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    ref={(el) => (cardRefs.current[1] = el)}
                    className="poly-hero-card-img two"
                  >
                    <img
                      src={require("../../../image/polymarket/hero-card-img-two.webp")}
                      alt="Polymarket clone script"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    ref={(el) => (cardRefs.current[2] = el)}
                    className="poly-hero-card-img three"
                  >
                    <img
                      src={require("../../../image/polymarket/hero-card-img-three.webp")}
                      alt="Polymarket clone script"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    ref={(el) => (cardRefs.current[3] = el)}
                    className="poly-hero-card-img four"
                  >
                    <img
                      src={require("../../../image/polymarket/hero-card-img-four.webp")}
                      alt="Polymarket clone script"
                    />
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>

        {/* about */}
        <article className="poly-about poly-mt primary__landing-content-container">
          <div className="row poly-about-row">
            <div className="col-lg-5">
              <h3 className="poly-subtitle">
                <span className="poly-span">What is a</span> Polymarket Clone
                Script?
              </h3>
            </div>
            <div className="col-lg-7">
              <div className="poly-about-content">
                <p>
                  <span>
                    A Polymarket clone script is a customizable and feature-rich
                    software solution that replicates the core functionalities
                    of Polymarket. It includes essential features like event
                    creation, market liquidity provision, decentralized trading,
                    and blockchain integration. This script is tailored to
                    provide a seamless user experience while leveraging the
                    power of decentralized finance (DeFi). By using a Polymarket
                    clone script, businesses can launch their prediction market
                    platform quickly and cost-effectively. The script can be
                    customized to meet specific requirements, making it a
                    flexible solution for entrepreneurs entering the blockchain
                    space.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* features */}
        <article className="poly-features poly-mt  ">
          <div className="primary__landing-content-container">
            <h3 className="poly-subtitle text-center">
              <span className="poly-span">Features of a </span>{" "}
              <div className="poly-inline ply-fe-title">
                Polymarket Clone Script
              </div>
            </h3>

            <div className="row mx-0 g-4 poly-features-row">
              <div className="col-lg-4 col-md-6">
                <div className="poly-fe-cards">
                  <div className="text-center">
                    <img
                      src={require("../../../image/polymarket/fe-img-one.webp")}
                      alt="Polymarket clone script"
                      className="poly-fe-img"
                    />
                  </div>
                  <h6>Decentralized Architecture</h6>
                  <p>
                    Operates on blockchain technology to ensure transparency and
                    security.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="poly-fe-cards">
                  <div className="text-center">
                    <img
                      src={require("../../../image/polymarket/fe-img-two.webp")}
                      alt="Polymarket clone script"
                      className="poly-fe-img"
                    />
                  </div>
                  <h6>User-Friendly Interface</h6>
                  <p>
                    A simple and intuitive design for easy navigation and
                    trading.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="poly-fe-cards">
                  <div className="text-center">
                    <img
                      src={require("../../../image/polymarket/fe-img-three.webp")}
                      alt="Polymarket clone script"
                      className="poly-fe-img"
                    />
                  </div>
                  <h6>Smart Contracts</h6>
                  <p>
                    Automates processes like payouts and ensures tamper-proof
                    transactions.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="poly-fe-cards">
                  <div className="ply-fe-img-cntr">
                    <img
                      src={require("../../../image/polymarket/fe-img-four.webp")}
                      alt="Polymarket clone script"
                      className="poly-fe-img"
                    />
                  </div>
                  <h6>Customizable Markets</h6>
                  <p>
                    Create prediction markets for any topic, including politics,
                    sports, and finance.
                  </p>
                </div>
              </div>

              <div className="col-lg-6 col-md-6">
                <div className="poly-fe-cards">
                  <div className="ply-fe-img-cntr">
                    <img
                      src={require("../../../image/polymarket/fe-img-five.webp")}
                      alt="Polymarket clone script"
                      className="poly-fe-img"
                    />
                  </div>
                  <h6>Liquidity Pools</h6>
                  <p>
                    Enable participants to provide liquidity and earn rewards.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="poly-fe-cards">
                  <div className="text-center">
                    <img
                      src={require("../../../image/polymarket/fe-img-six.webp")}
                      alt="Polymarket clone script"
                      className="poly-fe-img"
                    />
                  </div>
                  <h6>Multi-Currency Support</h6>
                  <p>Allows trading with cryptocurrencies and stablecoins.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="poly-fe-cards">
                  <div className="text-center">
                    <img
                      src={require("../../../image/polymarket/fe-img-seven.webp")}
                      alt="Polymarket clone script"
                      className="poly-fe-img"
                    />
                  </div>
                  <h6>Secure Wallet Integration</h6>
                  <p>
                    Supports popular wallets like MetaMask for seamless
                    transactions.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="poly-fe-cards">
                  <div className="text-center">
                    <img
                      src={require("../../../image/polymarket/fe-img-eight.webp")}
                      alt="Polymarket clone script"
                      className="poly-fe-img"
                    />
                  </div>
                  <h6>Real-Time Updates</h6>
                  <p>Provides live market data and event outcomes.</p>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* benefits */}
        <article className="poly-benefits ">
          <div className="poly-ben-inner primary__landing-content-container">
            <h3 className="poly-subtitle text-center ply-ben-title">
              <span className="poly-span">Benefits of </span>{" "}
              <div className="poly-inline">Using a Polymarket Clone Script</div>
            </h3>

            <div className="row mx-0 poly-ben-row">
              <div className="col-lg-4 col-md-6 poly-ben-cards">
                <div className="poly-ben-img-wrapper">
                  <img
                    src={require("../../../image/polymarket/ben-img-one.webp")}
                    alt="Polymarket clone script"
                  />
                </div>
                <h6>Cost-Efficient Development</h6>
                <p>
                  Save time and resources by leveraging a pre-built solution.
                </p>
              </div>
              <div className="col-lg-4 col-md-6 poly-ben-cards">
                <div className="poly-ben-img-wrapper">
                  <img
                    src={require("../../../image/polymarket/ben-img-two.webp")}
                    alt="Polymarket clone script"
                  />
                </div>
                <h6>Customizable Solution</h6>
                <p>
                  Modify the script to suit your specific business requirements.
                </p>
              </div>
              <div className="col-lg-4 col-md-6 poly-ben-cards">
                <div className="poly-ben-img-wrapper">
                  <img
                    src={require("../../../image/polymarket/ben-img-three.webp")}
                    alt="Polymarket clone script"
                  />
                </div>
                <h6>Fast Deployment</h6>
                <p>
                  Launch your platform quickly with minimal development efforts.
                </p>
              </div>
              <div className="col-lg-2 poly-ben-mobile-none "></div>
              <div className="col-lg-4 col-md-6 poly-ben-cards">
                <div className="poly-ben-img-wrapper">
                  <img
                    src={require("../../../image/polymarket/ben-img-four.webp")}
                    alt="Polymarket clone script"
                  />
                </div>
                <h6>Scalability</h6>
                <p>Easily expand your platform as your user base grows.</p>
              </div>
              <div className="col-lg-4 col-md-6 poly-ben-cards">
                <div className="poly-ben-img-wrapper">
                  <img
                    src={require("../../../image/polymarket/ben-img-five.webp")}
                    alt="Polymarket clone script"
                  />
                </div>
                <h6>Decentralized Operations</h6>
                <p>Gain user trust with blockchain-powered transparency.</p>
              </div>
              <div className="col-lg-2 poly-ben-mobile-none"></div>
            </div>
          </div>
        </article>

        {/* how to develop */}
        <article className="poly-dev poly-mt primary__landing-content-container">
          <h3 className="poly-subtitle ">
            <span className="poly-span">How to develop</span>{" "}
            <div className="poly-inline">a Polymarket Clone Script</div>
          </h3>
          <p className="ply-dev-content">
            Developing a Polymarket clone script involves several steps. Here’s
            a step-by-step guide
          </p>

          <div className="why-custom-swiper">
            <Swiper
              spaceBetween={20}
              slidesPerView={4}
              modules={[Navigation, A11y, Pagination]}
              pagination={{
                clickable: true,
                // el: ".forex-paginate",
              }}
              scrollbar={{ draggable: true }}
              navigation={{
                prevEl: ".why-custom-prev-arrow",
                nextEl: ".why-custom-next-arrow",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
              }}
              onSlideChange={handleSlideSecChange}
              onReachBeginning={() => setIsPrevSecDisabled(true)}
              onReachEnd={() => setIsNextSecDisabled(true)}
              onFromEdge={() => {
                setIsPrevSecDisabled(false);
                setIsNextSecDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="ply-dev-cards">
                  <img
                    src={require("../../../image/polymarket/dev-img-one.webp")}
                    alt="Polymarket clone script"
                  />
                  <div className="ply-dev-card-contents">
                    <h4>Step 1</h4>
                    <h6>Define Your Requirements</h6>
                    <p>
                      Determine the features, functionalities, and design
                      elements you want to include in your platform. Identify
                      your target audience and market niche.
                    </p>
                  </div>
                  <span className="ply-num-span">01</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ply-dev-cards">
                  <img
                    src={require("../../../image/polymarket/dev-img-two.webp")}
                    alt="Polymarket clone script"
                  />
                  <div className="ply-dev-card-contents two">
                    <h4>Step 2</h4>
                    <h6>Choose the Right Blockchain</h6>
                    <p>
                      Select a blockchain network that suits your platform’s
                      requirements. Popular options include Ethereum, Binance
                      Smart Chain, and Polygon.
                    </p>
                  </div>
                  <span className="ply-num-span">02</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ply-dev-cards">
                  <img
                    src={require("../../../image/polymarket/dev-img-three.webp")}
                    alt="Polymarket clone script"
                  />
                  <div className="ply-dev-card-contents">
                    <h4>Step 3</h4>
                    <h6>Develop Smart Contracts</h6>
                    <p>
                      Create smart contracts to automate trading, payouts, and
                      other platform functionalities. Ensure that the contracts
                      are secure and efficient.
                    </p>
                  </div>
                  <span className="ply-num-span">03</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ply-dev-cards">
                  <img
                    src={require("../../../image/polymarket/dev-img-four.webp")}
                    alt="Polymarket clone script"
                  />
                  <div className="ply-dev-card-contents">
                    <h4>Step 4</h4>
                    <h6>Design the User Interface</h6>
                    <p>
                      Develop a user-friendly interface that provides a seamless
                      experience for users. Focus on intuitive navigation and
                      attractive design.
                    </p>
                  </div>
                  <span className="ply-num-span">04</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ply-dev-cards">
                  <img
                    src={require("../../../image/polymarket/dev-img-five.webp")}
                    alt="Polymarket clone script"
                  />
                  <div className="ply-dev-card-contents">
                    <h4>Step 5</h4>
                    <h6> Integrate Wallets</h6>
                    <p>
                      Incorporate secure cryptocurrency wallets to enable users
                      to deposit, withdraw, and trade tokens.
                    </p>
                  </div>
                  <span className="ply-num-span">05</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ply-dev-cards">
                  <img
                    src={require("../../../image/polymarket/dev-img-six.webp")}
                    alt="Polymarket clone script"
                  />
                  <div className="ply-dev-card-contents">
                    <h4>Step 6</h4>
                    <h6> Test the Platform</h6>
                    <p>
                      Perform thorough testing to resolve & identify any bugs or
                      issues. Ensure that the platform is secure, reliable, and
                      user-friendly.
                    </p>
                  </div>
                  <span className="ply-num-span">06</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ply-dev-cards">
                  <img
                    src={require("../../../image/polymarket/dev-img-seven.webp")}
                    alt="Polymarket clone script"
                  />
                  <div className="ply-dev-card-contents">
                    <h4>Step 7</h4>
                    <h6> Launch the Platform</h6>
                    <p>
                      Once the platform is ready, launch it in the market.
                      Promote your platform through marketing and outreach
                      strategies to attract users.
                    </p>
                  </div>
                  <span className="ply-num-span">07</span>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="why-custom-btn-wrapper st-key-btn-wrapper">
              <button
                className={`why-custom-prev-arrow st-key-left-btn ${
                  isPrevSecDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevSecDisabled ? "#6E6F70" : "#0f0f0f",
                  cursor: isPrevSecDisabled ? "not-allowed" : "pointer",
                  backgroundColor: isPrevSecDisabled
                    ? "#0f0f0f28 "
                    : "#24272899",
                }}
              >
                <i className="fa-solid fa-arrow-left"></i>
              </button>
              <button
                className={`why-custom-next-arrow st-key-right-btn ${
                  isNextSecDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextSecDisabled ? "#6E6F70" : "#0f0f0f",
                  cursor: isNextSecDisabled ? "not-allowed" : "pointer",
                  backgroundColor: isNextSecDisabled
                    ? "#0f0f0f28"
                    : "#24272899",
                }}
              >
                <i className="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </article>

        {/* cost */}
        <article className="poly-features poly-mt  ">
          <div className="primary__landing-content-container">
            <h3 className="poly-subtitle text-center">
              <span className="poly-span">Cost of Developing </span>{" "}
              <div className="poly-inline ply-fe-title">
                A Polymarket Clone Script
              </div>
            </h3>
            <p className="ply-cost-content">
              The cost of developing a Polymarket clone script depends on
              several factors, including
            </p>
            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="custom-ai-btn re-hero-btn"
              >
                {" "}
                <div className="re-btn-txt">Get In Touch</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>

            <div className="ply-cost-gallery">
              <div className="ply-box">
                <img
                  src={require("../../../image/polymarket/cost-img-one.webp")}
                  alt="Polymarket clone script"
                />
                <span>
                  <div className="inner_box_content">
                    <h4>Features and Functionalities</h4>
                    <p>
                      The more features you include, the higher the development
                      cost.
                    </p>
                  </div>
                </span>
              </div>
              <div className="ply-box">
                <img
                  src={require("../../../image/polymarket/cost-img-two.webp")}
                  alt="Polymarket clone script"
                />
                <span>
                  <div className="inner_box_content">
                    <h4>Blockchain Network</h4>
                    <p>
                      The choice of blockchain network affects development
                      costs.
                    </p>
                  </div>
                </span>
              </div>
              <div className="ply-box">
                <img
                  src={require("../../../image/polymarket/cost-img-three.webp")}
                  alt="Polymarket clone script"
                />
                <span>
                  <div className="inner_box_content">
                    <h4>Customization</h4>
                    <p>
                      Extensive customization requires additional time and
                      resources, increasing the cost.
                    </p>
                  </div>
                </span>
              </div>
              <div className="ply-box">
                <img
                  src={require("../../../image/polymarket/cost-img-four.webp")}
                  alt="Polymarket clone script"
                />
                <span>
                  <div className="inner_box_content">
                    <h4>Development Team</h4>
                    <p>
                      The expertise and location of the development team
                      influence pricing.
                    </p>
                  </div>
                </span>
              </div>
              <div className="ply-box">
                <img
                  src={require("../../../image/polymarket/cost-img-five.webp")}
                  alt="Polymarket clone script"
                />
                <span>
                  <div className="inner_box_content">
                    <h4>Timeline</h4>
                    <p>
                      Urgent projects may incur higher costs due to expedited
                      development.
                    </p>
                  </div>
                </span>
              </div>
            </div>

            <p className="ply-cost-content btm">
              On average, the cost of developing a Polymarket clone script can
              range from $10,000 to $50,000, depending on the above factors.
            </p>
          </div>
        </article>

        {/* future */}
        <article className="poly-future poly-mt primary__landing-content-container">
          <div className="row mx-0 ply-future-row">
            <div className="col-lg-6">
              <h3 className="poly-subtitle">
                {" "}
                <span className="poly-span">Future of</span> Prediction Markets
              </h3>
              <p className="poly-choose-content ply-future-content">
                Prediction markets are gaining traction as innovative platforms
                for forecasting and decision-making. With advancements in
                blockchain technology, these markets are expected to grow
                rapidly. By investing in a Polymarket clone script, businesses
                can capitalize on this trend and establish themselves as leaders
                in the prediction market space.
              </p>
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
            <div className="col-lg-6 text-center">
              <div className="future-img-outer">
                <div className="future-img">
                  <img
                    src={require("../../../image/polymarket/future-bg.webp")}
                    alt="Polymarket clone script"
                  />
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* why choose */}
        <article className="poly-choose poly-mt primary__landing-content-container">
          <div className="row mx-0 poly-choose-row">
            <div className="col-lg-6 ply-choose-col">
              <img
                src={require("../../../image/polymarket/choose.webp")}
                alt="Polymarket clone script"
              />
            </div>
            <div className="col-lg-6">
              <h3 className="poly-subtitle ">
                <span className="poly-span">Why Choose A</span>{" "}
                <div className="poly-inline">Polymarket Clone Script</div>
              </h3>
              <p className="poly-choose-content">
                A Polymarket clone script is the ideal choice for entrepreneurs
                and businesses looking to enter the prediction market industry.
                By using this script, you can launch a platform that empowers
                users to trade and speculate on event outcomes, creating a new
                revenue stream while fostering a vibrant community of traders.
              </p>
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn re-hero-btn"
              >
                <div className="re-btn-txt"> Get Free Demo</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </article>

        {/* how to get */}
        <article className="poly-mt primary__landing-content-container">
          <h3 className="poly-subtitle text-center">
            <span className="poly-span">How to Get a</span>{" "}
            <div className="poly-inline">Polymarket Clone Script</div>
          </h3>
          <p className="poly-choose-content ply-get-content">
            To acquire a Polymarket clone script, partner with a reputable
            blockchain development company. They can provide you with a robust,
            secure, and fully customizable script tailored to your business
            needs. Ensure that the provider offers post-launch support,
            maintenance, and updates for seamless operations.
          </p>

          <div className="ply-get-img-wrap">
            <div className="ply-get-img ply-get-left">
              <img
                src={require("../../../image/polymarket/get-left-img.webp")}
                alt="Polymarket clone script"
              />
            </div>
            <div className="ply-get-img ply-get-center">
              <img
                src={require("../../../image/polymarket/get-center-img.webp")}
                alt="Polymarket clone script"
              />
            </div>
            <div className="ply-get-img ply-get-right">
              <img
                src={require("../../../image/polymarket/get-right-img.webp")}
                alt="Polymarket clone script"
              />
            </div>
          </div>
        </article>

        {/* Take Away*/}
        <div className="custom-get-in-touch ply-ta">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title">Take Away</h5>
            <p className="custom-get-content">
              A Polymarket clone script is a perfect solution for creating a
              decentralized prediction market platform that mirrors the success
              of Polymarket. With its advanced features, blockchain integration,
              and user-friendly interface, this script can help you establish a
              thriving business in the decentralized finance ecosystem. Start
              your journey with a Polymarket clone script today and tap into the
              growing demand for prediction markets!
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-3 re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          How does a Polymarket clone script ensure security?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The script uses blockchain technology and smart
                          contracts to provide transparency, immutability, and
                          secure transactions. It also includes robust security
                          measures to protect user data and funds.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          Can the Polymarket clone script be customized?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, the Polymarket clone script is highly
                          customizable. You can tailor the design, features, and
                          functionalities to meet your specific business needs
                          and market demands.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          What are the revenue models for a Polymarket clone
                          platform?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          A Polymarket clone platform can generate revenue
                          through transaction fees, premium features, token
                          sales, and advertising opportunities within the
                          platform.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq44"
                        >
                          How long does it take to develop a Polymarket clone
                          script?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The development timeline depends on the level of
                          customization and complexity. On average, it can take
                          4-8 weeks to develop and deploy a Polymarket clone
                          script.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead5">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq5"
                          aria-expanded="true"
                          aria-controls="faq5"
                        >
                          What makes a Polymarket clone script cost-effective?
                        </div>
                      </div>

                      <div
                        id="faq5"
                        className="collapse"
                        aria-labelledby="faqhead5"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Using a Polymarket clone script eliminates the need to
                          build a platform from scratch, reducing both time and
                          development costs. Its pre-built structure allows for
                          quicker deployment and lower expenses.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead6">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq6"
                          aria-expanded="true"
                          aria-controls="faq6"
                        >
                          How can liquidity pools benefit a Polymarket clone
                          platform?
                        </div>
                      </div>

                      <div
                        id="faq6"
                        className="collapse"
                        aria-labelledby="faqhead6"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Liquidity pools ensure smooth trading by providing
                          sufficient liquidity for market outcomes. This feature
                          enhances user experience and attracts more
                          participants to the platform.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Polymarket;
